const STEPS = [
  {
    n: "01",
    title: "Rozmowa",
    body:
      "30 minut. Pytamy o produkt, ofertę, region, klientów. Słuchamy, nie sprzedajemy.",
  },
  {
    n: "02",
    title: "Analiza",
    body:
      "Patrzymy na konkurencję, słowa kluczowe, ścieżki zakupowe. Wskazujemy gdzie wycieka budżet.",
  },
  {
    n: "03",
    title: "Projekt",
    body:
      "Strona, formularz, powiadomienia, analityka. Premium design, pełna treść po polsku.",
  },
  {
    n: "04",
    title: "Uruchomienie",
    body:
      "Publikacja, kampania Google Ads, codzienna optymalizacja. Pierwsze leady w 14 dni.",
  },
];

export default function AgencyProcess() {
  return (
    <section
      id="jak-to-dziala"
      data-testid="agency-process"
      className="relative py-20 lg:py-28 border-t border-white/5"
    >
      <div className="max-w-7xl mx-auto px-5 sm:px-8 lg:px-10">
        <div className="max-w-3xl">
          <div className="text-[11px] font-bold uppercase tracking-[0.18em] text-brand-yellow">
            Jak to działa
          </div>
          <h2 className="mt-3 font-heading font-extrabold text-white text-3xl sm:text-4xl lg:text-5xl tracking-tight leading-[1.05]">
            Cztery kroki.{" "}
            <span className="text-white/40">Bez zaskoczeń.</span>
          </h2>
        </div>

        <div className="mt-12 lg:mt-16 grid md:grid-cols-2 lg:grid-cols-4 gap-5">
          {STEPS.map((s, i) => (
            <div
              key={s.n}
              data-testid={`agency-step-${i}`}
              className="relative rounded-3xl bg-white/[0.03] ring-1 ring-white/10 p-7 lg:p-8 hover:ring-white/20 transition-all"
            >
              <div className="font-heading font-extrabold text-brand-yellow text-5xl lg:text-6xl leading-none tracking-tight">
                {s.n}
              </div>
              <h3 className="mt-5 font-heading font-bold text-white text-xl tracking-tight">
                {s.title}
              </h3>
              <p className="mt-2 text-[14.5px] text-white/55 leading-relaxed">
                {s.body}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
